import { ISSUE_ATTRIBUTE_NAMES } from './issue-attribute-names';

export const CREATE_FORM_SEPARATOR = 'CREATE_FORM_SEPARATOR';

export const CREATE_FORM_FIELD_NAMES = [
  ISSUE_ATTRIBUTE_NAMES.STATUS, ISSUE_ATTRIBUTE_NAMES.TITLE, ISSUE_ATTRIBUTE_NAMES.CUSTOM_IDENTIFIER, ISSUE_ATTRIBUTE_NAMES.DESCRIPTION,
  ISSUE_ATTRIBUTE_NAMES.SUGGESTED_ANSWER, ISSUE_ATTRIBUTE_NAMES.ATTACHMENTS_ATTRIBUTES, ISSUE_ATTRIBUTE_NAMES.TARGET_URN,
  CREATE_FORM_SEPARATOR, ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO, ISSUE_ATTRIBUTE_NAMES.LOCATION_DESCRIPTION,
  ISSUE_ATTRIBUTE_NAMES.DUE_DATE, ISSUE_ATTRIBUTE_NAMES.CO_REVIEWERS, ISSUE_ATTRIBUTE_NAMES.DISTRIBUTION_LIST,
];

export const CREATE_FORM_FIELD_NAMES_TO_KEEP_ON_CREATE_ANOTHER = [
  ISSUE_ATTRIBUTE_NAMES.STATUS, ISSUE_ATTRIBUTE_NAMES.DUE_DATE, ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO,
  ISSUE_ATTRIBUTE_NAMES.CO_REVIEWERS, ISSUE_ATTRIBUTE_NAMES.DISTRIBUTION_LIST,
];
